export function roundToTwo(num: number) {
  return +(Math.round((num + 'e+2') as unknown as number) + 'e-2')
}

export function wordFormat(word: string) {
  return !word ? word : word[0].toUpperCase() + word.substring(1).toLowerCase()
}

export const fieldFormatter = (value: number | undefined) =>
  `${value}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

export const instagramNumberFormatter = (value: number | undefined): string => {
  const number = value ?? 0
  if (number > 1000000) return `${(number / 1000000).toFixed(2)}M`
  if (number > 1000) return `${(number / 1000).toFixed(2)}K`
  return number.toString()
}

export const readRateFormatter = (sent: number = 0, read: number = 0) => {
  return Math.round((read / (sent != 0 ? sent : 1)) * 100)
}
